import { render } from "./TrainingSkillCategoryComponent.vue?vue&type=template&id=1a403256&scoped=true"
import script from "./TrainingSkillCategoryComponent.vue?vue&type=script&lang=js"
export * from "./TrainingSkillCategoryComponent.vue?vue&type=script&lang=js"

import "./TrainingSkillCategoryComponent.vue?vue&type=style&index=0&id=1a403256&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a403256"]])

export default __exports__